import { withInstall, withNoopInstall } from '@jdesign-vue/utils'
import Carousel from './src/carousel.vue'
import CarouselItem from './src/carousel-item.vue'

export const JdCarousel = withInstall(Carousel, {
  CarouselItem,
})

export default JdCarousel

export const JdCarouselItem = withNoopInstall(CarouselItem)

export * from './src/carousel'
export * from './src/carousel-item'
export * from './src/constants'

export type { CarouselInstance, CarouselItemInstance } from './src/instance'
